import moment from "moment";
const SectionTitle = () => import("../SectionTitle/SectionTitle.vue")
import planningService from "@/services/planning";
import { mapGetters } from "vuex";

export default {
  components: {
    SectionTitle,
  },
  data: () => ({
    dayList: [],
    errorPlanning: false,
  }),
  created() {
  },
  mounted(){
    this.updateDayList();
    this.getAdvMissionToday();
  },
  computed: {
    ...mapGetters({
      spinnerPlanning: "isLoading",
    }),
  },
  methods: {
    updateDayList(){
      this.dayList = [
        {
          name: this.$t('planning-view-today-missions-title'),
          start: moment().format("dddd DD MMMM YYYY"),
          missions: [],
        },
        {
          name: this.$t('planning-view-tomorrow-missions-title'),
          start: moment()
            .add(1, "days")
            .format("dddd DD MMMM YYYY"),
          missions: [],
        },
      ];
    },
    getAdvMissionToday() {
      const vue = this;
      const moment0 = moment().startOf("day");
      const moment24 = moment()
        .startOf("day")
        .add(1, "days");
      const moment48 = moment()
        .startOf("day")
        .add(2, "days");

      // const timeRange = `${+moment0}/${+moment48}`;
      const timeRange = {
        startTime: moment0.format("x"),
        endTime: moment48.format("x")
      }
      planningService
        .getPlanning(timeRange)
        .then((res) => {
          if (res.success) {
            const today = res.data
              .filter(
                (m) => moment0 <= moment(m.start) && moment24 >= moment(m.start)
              )
              .map((d) => {
                d.start = vue.formatTime(d.start);
                d.end = vue.formatTime(d.end);
                return d;
              });
            const tomorrow = res.data
              .filter(
                (m) =>
                  moment24 <= moment(m.start) && moment48 >= moment(m.start)
              )
              .map((d) => {
                d.start = vue.formatTime(d.start);
                d.end = vue.formatTime(d.end);
                return d;
              });
              vue.dayList[0].missions = today;
              vue.dayList[1].missions = tomorrow;
            return;
          }
          vue.errorPlanning = true;
        })
        .catch((err) => {
          vue.errorPlanning = true;
        });
    },

    formatTime(time) {
      return moment(time).format("HH[h]mm");
    },
  },
};
